import { Component, Inject, OnInit, ChangeDetectorRef } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

@Component({
    selector: 'app-third-party-notice',
    templateUrl: './third-party-notice-dialog.component.html',
    styleUrls: ['./third-party-notice-dialog.component.scss'],
    standalone: false
})
export class ThirdPartyNoticeComponent implements OnInit {
  formattedLicenFile = ''
  urlEncoded = '/assets/third-party-licenses.txt'

  constructor(
    private dialogRef: MatDialogRef<ThirdPartyNoticeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.openLicenceFile()
  }

  openLicenceFile() {
    if (this.data?.url) {
      this.urlEncoded = this.data.url
    }

    this.http.get(this.urlEncoded, { responseType: 'text' }).subscribe({
      next: (text) => {
        this.formattedLicenFile = text
        this.cdr.detectChanges()
      },
      error: (error) => {
        console.error('Error loading third-party licenses:', error)
        this.formattedLicenFile = 'Error loading third-party licenses. Please try again later.'
        this.cdr.detectChanges()
      }
    })
  }

  cancelSelected(): void {
    this.dialogRef.close()
  }
}
